import { createRoutine } from 'redux-saga-routines';
import { IMessageState } from './message.interface';
import { mergeArrayAndOverrideDuplicates } from '../utils/index.common';

const initialMessageState: IMessageState = {
  messages: [],
  error: false,
  loading: false,
  success: false,
  sending: false,
  sendSuccess: false,
  sendFailuer: false,
  loadingOlder: false,
  meta: {
    perPage: 0,
    totalPages: 0,
    totalResults: 0,
    curPage: 0
  },
}

export const sendMessage = createRoutine('SEND_MESSAGE')
export const getAllMessages = createRoutine('GET_ALL_MESSAGES')
export const clearMessageStatus = createRoutine('CLEAR_MESSAGE_STATUS')

export default function message(state = initialMessageState, action: any) {
  switch (action.type) {
    case sendMessage.TRIGGER: {
      return { ...state, sending: true, sendSuccess: false, sendFailuer: false }

    }
    case sendMessage.SUCCESS: {
      return {
        ...state,
        messages: mergeArrayAndOverrideDuplicates(state.messages, action.payload),
        sending: false,
        sendSuccess: true,
        sendFailuer: false
      }

    }
    case sendMessage.FAILURE: {
      return {
        ...state,
        sending: false,
        sendSuccess: false,
        sendFailuer: true
      }
    }
    case getAllMessages.TRIGGER: {
      if (action.payload.cur_page > 1) {
        return { ...state, loadingOlder: true, error: false, success: false }
      }
      return { ...state, loading: true, messages: [], error: false, success: false }
    }
    case getAllMessages.SUCCESS: {
      return {
        ...state,
        loading: false,
        loadingOlder: false,
        success: true,
        messages: mergeArrayAndOverrideDuplicates(action.payload.messages, state.messages),
        meta: action.payload.meta,
        error: false
      }
    }
    case getAllMessages.FAILURE: {
      return {
        ...state,
        loading: false,
        success: false,
        error: true
      }
    }
    case clearMessageStatus.TRIGGER: {
      return{
        ...state,
        sending: false,
        sendSuccess: false,
        sendFailuer: false
      }
    }

    default:
      return state
  }
}
